// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"privacy_wrapper__w_tLk","ar":"privacy_ar__XiD_y","content":"privacy_content__jv6g8"};